(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_ab-869f3bwq4-product-bundles"] && !Shopify.designMode) return;
  try {
    /**
   * Block: AB 869f3bwq4 product bundles
   * -----------------------------------------------------------------------------
   * Drives the native scroll-snap track with the prev/next arrows, dots and
   * right edge fade, and updates a card's image and prices when its variant
   * select changes.
   *
   */
  class Ab869f3bwq4ProductBundles extends HTMLElement {
    /**
     * Caches elements and binds events.
     */
    connectedCallback() {
      this.track = this.querySelector('[js-product-bundles="track"]')
      this.cards = [...this.querySelectorAll('[js-product-bundles="card"]')]
      this.previousButton = this.querySelector(
        '[js-product-bundles="previous"]',
      )

      this.nextButton = this.querySelector('[js-product-bundles="next"]')
      this.dots = [...this.querySelectorAll('[js-product-bundles="dot"]')]
      this.navigation = this.querySelector('[js-product-bundles="navigation"]')
      this.pagination = this.querySelector('[js-product-bundles="pagination"]')
      this.fade = this.querySelector('[js-product-bundles="fade"]')

      this.reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)',
      )

      this.querySelectorAll('[js-product-bundles="variant-select"]')
        .forEach((select) => {
          select.addEventListener('change', this.handleVariantChange)
        })

      if (!this.track || !this.previousButton || !this.nextButton) {
        return
      }

      this.handleScroll = this.handleScroll.bind(this)

      this.previousButton.addEventListener('click', () => {
        this.scrollByCard(-1)
      })

      this.nextButton.addEventListener('click', () => {
        this.scrollByCard(1)
      })

      this.track.addEventListener('scroll', this.handleScroll, { passive: true })

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.scrollToCard(index))
      })

      // Re-runs once the A/B gate shows the block and when lazy images load
      this.resizeObserver = new ResizeObserver(this.handleScroll)
      this.resizeObserver.observe(this.track)

      this.update()
    }

    /**
     * Removes the scroll listener and resize observer.
     */
    disconnectedCallback() {
      if (this.track && this.handleScroll) {
        this.track.removeEventListener('scroll', this.handleScroll)
      }

      if (this.resizeObserver) {
        this.resizeObserver.disconnect()
      }
    }

    /**
     * Shows the selected variant's image, prices and discount tag.
     * @param {Event} event - Select change event.
     */
    handleVariantChange(event) {
      const select = event.target
      const option = select.selectedOptions[0]

      if (!option) {
        return
      }

      const card = select.closest('[js-product-bundles="card"]')
      const price = card.querySelector('[js-product-bundles="price"]')
      const compareAtPrice = card.querySelector(
        '[js-product-bundles="compare-at-price"]',
      )

      const saving = card.querySelector('[js-product-bundles="saving"]')
      const discount = card.querySelector('[js-product-bundles="discount"]')
      const image = card.querySelector('[js-product-bundles="image"]')
      const isOnSale = option.dataset.compareAtPrice !== ''

      price.textContent = option.dataset.price
      price.classList.toggle('ab-869f3bwq4-product-bundles__price--sale', isOnSale)
      compareAtPrice.textContent = option.dataset.compareAtPrice
      compareAtPrice.hidden = !isOnSale
      saving.textContent = option.dataset.saving
      saving.hidden = !isOnSale

      if (discount) {
        discount.textContent = option.dataset.discount
        discount.hidden = option.dataset.discount === ''
      }

      if (!image || !option.dataset.imageSrc) {
        return
      }

      image.srcset = option.dataset.imageSrcset
      image.src = option.dataset.imageSrc
      image.alt = option.dataset.imageAlt
    }

    /**
     * Throttles state updates to one per animation frame.
     */
    handleScroll() {
      if (this.frame) {
        return
      }

      this.frame = window.requestAnimationFrame(() => {
        this.frame = null
        this.update()
      })
    }

    /**
     * Gets the index of the card closest to the start of the track.
     * @returns {Number}
     */
    getActiveIndex() {
      const offset = this.track.scrollLeft
      const firstCardLeft = this.cards[0].offsetLeft

      return this.cards.reduce((closest, card, index) => {
        const distance = Math.abs(card.offsetLeft - firstCardLeft - offset)
        const closestCardLeft = this.cards[closest].offsetLeft
        const closestDistance = Math.abs(closestCardLeft - firstCardLeft - offset)

        return distance < closestDistance ? index : closest
      }, 0)
    }

    /**
     * Gets the scroll behaviour, jumps when reduced motion is preferred.
     * @returns {String}
     */
    getScrollBehavior() {
      return this.reducedMotion.matches ? 'auto' : 'smooth'
    }

    /**
     * Scrolls the track by one card width plus the gap.
     * @param {Number} direction - 1 for next, -1 for previous.
     */
    scrollByCard(direction) {
      const step = this.cards[1].offsetLeft - this.cards[0].offsetLeft

      this.track.scrollBy({
        behavior: this.getScrollBehavior(),
        left: step * direction,
      })
    }

    /**
     * Scrolls the track so the card at the index sits at the start.
     * @param {Number} index - Card index.
     */
    scrollToCard(index) {
      this.track.scrollTo({
        behavior: this.getScrollBehavior(),
        left: this.cards[index].offsetLeft - this.cards[0].offsetLeft,
      })
    }

    /**
     * Hides the controls when all cards fit, otherwise disables the arrows at
     * the ends, shows the fade while more cards are to the right and marks the
     * active dot.
     */
    update() {
      // No real size while the A/B gate hides the block, keep the defaults
      if (this.track.clientWidth === 0) {
        return
      }

      const maxScroll = this.track.scrollWidth - this.track.clientWidth
      const canScroll = maxScroll > 1
      const hasNext = canScroll && this.track.scrollLeft < maxScroll - 1

      this.navigation.hidden = !canScroll
      this.pagination.hidden = !canScroll
      this.fade.hidden = !canScroll

      this.classList.toggle(
        'ab-869f3bwq4-product-bundles__container--has-next',
        hasNext,
      )

      if (!canScroll) {
        return
      }

      // Several cards are visible so the last ones never reach the start
      const activeIndex = hasNext
        ? this.getActiveIndex()
        : this.cards.length - 1

      this.previousButton.disabled = this.track.scrollLeft <= 1
      this.nextButton.disabled = !hasNext

      this.dots.forEach((dot, index) => {
        const isActive = index === activeIndex

        dot.setAttribute('aria-current', isActive ? 'true' : 'false')
      })
    }
  }

  if (!customElements.get('ab-869f3bwq4-product-bundles')) {
    customElements.define(
      'ab-869f3bwq4-product-bundles',
      Ab869f3bwq4ProductBundles,
    )
  }
  } catch(e) { console.error(e); }
})();

})();
